function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import Link from 'react-native-web-ui-components/Link';
import StylePropType from 'react-native-web-ui-components/StylePropType';
const styles = StyleSheet.create({
  handle: {
    paddingLeft: 10,
    paddingTop: 11
  }
});

const RemoveHandle = ({
  theme,
  onRemovePress,
  removeLabel,
  removeStyle,
  ...props
}) => /*#__PURE__*/React.createElement(Link, _extends({}, props, {
  auto: true,
  onPress: onRemovePress,
  style: [styles.handle, removeStyle],
  type: theme.colors.primary
}), removeLabel);

RemoveHandle.propTypes = {
  theme: PropTypes.shape().isRequired,
  onRemovePress: PropTypes.func.isRequired,
  removeLabel: PropTypes.node.isRequired,
  removeStyle: StylePropType
};
RemoveHandle.defaultProps = {
  removeStyle: null
};
export default RemoveHandle;